import Trader1 from '../../../../../../assets/svg/CopytradingDropdown/Trader1.svg'
import Trader2 from '../../../../../../assets/svg/CopytradingDropdown/Trader2.svg'
import Trader3 from '../../../../../../assets/svg/CopytradingDropdown/Trader3.svg'

export const DROPDOWN_COPYTRADING_TRADERS_BACKGROUND_URL = [Trader1, Trader2, Trader3]
